import { render, staticRenderFns } from "./MerchantAuditDetail.vue?vue&type=template&id=4d5592ff&scoped=true"
import script from "./MerchantAuditDetail.vue?vue&type=script&lang=js"
export * from "./MerchantAuditDetail.vue?vue&type=script&lang=js"
import style0 from "./MerchantAuditDetail.vue?vue&type=style&index=0&id=4d5592ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5592ff",
  null
  
)

export default component.exports